export default __webpack_public_path__ + "static/media/img-guide-mobile-bg@3x.4ffb0149.png";